import './ffsCalc/ffsCalcCardStyles.css'

import { Tabs, TabsProps, Typography } from 'antd'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { GeckoComponentModel } from 'types'

import { FfsSharedValueProvider } from './ffsCalc/FfsSharedValues'
import { FfsLevelOneCalc } from './ffsCalc/levelOne/FfsLevelOneCalc'
import { FfsLevelTwoCalc } from './ffsCalc/levelTwo/FfsLevelTwoCalc'

const { Title } = Typography

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Width = '24rem'

export const CardView: FC<IndicationDetailCardProps> = () => {
  const { assetModel, relevantThicknessCDF: thicknessCdf } = useIndicationData()
  const componentModel: GeckoComponentModel | undefined = useMemo(() => {
    const components = assetModel?.data.components
    const componentId = thicknessCdf?.tags.component
    if (!components || !componentId) {
      return undefined
    }

    return components.get(componentId) ?? undefined
  }, [assetModel?.data.components, thicknessCdf?.tags.component])

  const { indication: indicationItem } = useIndicationData()
  const levelOneProps = useMemo(
    () => ({
      indicationItem,
      componentModel,
      thicknessCdf,
    }),
    [componentModel, indicationItem, thicknessCdf]
  )

  const tabItems = useMemo<TabsProps['items']>(
    () => [
      {
        key: 'ffs-level-1',
        label: 'Level 1',
        children: <FfsLevelOneCalc {...levelOneProps} />,
      },
      {
        key: 'ffs-level-2',
        label: 'Level 2',
        children: <FfsLevelTwoCalc {...levelOneProps} />,
      },
    ],
    [levelOneProps]
  )

  return (
    <CardContainer>
      <Title level={3}>FFS Calculations</Title>
      <FfsSharedValueProvider>
        <Tabs
          defaultActiveKey={tabItems![0].key}
          items={tabItems}
          animated={{ inkBar: true, tabPane: true }}
        />
      </FfsSharedValueProvider>
    </CardContainer>
  )
}
